
import React, { useState } from "react";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { CloseIcon, FilterIcon, filterBlackIcon } from "../../../assets/images";
import { RadioContainer } from "../../../components/commons";

type AppProps = {
  activeStatus: string;
  activeStatusValue: string;
  setActiveStatus: React.Dispatch<React.SetStateAction<string>>;
  setClearFilter: (data: boolean) => void;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
  setActiveStatusValue: React.Dispatch<React.SetStateAction<string>>;
};

export const CATEGORY_STATUS_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    _id: "1",
    name: "Active",
  },
  {
    id: "0",
    _id: "0",
    name: "In Active",
  },
];

const ClientCategoryFilter = ({
  setActiveStatusValue,
  activeStatus,
  activeStatusValue,
  setClearFilter,
  setActiveStatus,
  setOffset,
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);

  const resetFilterData = () => {
    setActiveStatusValue(activeStatus.toString());
  };
  const handleSubmit = () => {
    setActiveStatus(activeStatusValue);
    setClearFilter(false);
  };

  const handleSetCategoryStatusRadioValue = (radioValue: string) => {
    setActiveStatusValue(radioValue);
  };

  const clearFilter = () => {
    setActiveStatusValue("");
    setActiveStatus("");
    setOffset(0);
    setClearFilter(true);
  };
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        resetFilterData();
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="secondary"
        style={
          toggle || (activeStatusValue !== "1" && activeStatusValue !== "0")
            ? { border: "1px solid#bfcbe1" }
            : {
                color: "#dd4433",
                border: "1px solid #dd4433",
                backgroundColor: "#fff6f5",
              }
        }
        outline
      >
        <img src={toggle?FilterIcon:filterBlackIcon } alt=""/>

      </DropdownToggle>

      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
                setClearFilter(false);
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          <div className="mt-4 ml-1">
            <h4>Category Status</h4>
            <div>
              <RadioContainer
                optionsList={CATEGORY_STATUS_RADIO_OPTIONS}
                handleSetRadioValue={handleSetCategoryStatusRadioValue}
                radioValue={activeStatusValue}
                alignment="vertical"
              />
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end p-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default ClientCategoryFilter;

